import React from 'react';
import BoostedComponent from './BoostedComponent'
import ReservationInformations from './ReservationInformations'
import DateInput from './DateInput'
import ReservationMultiplesDispo  from './ReservationMultiples1'
import ReservationMultiplesHoraire from './ReservationMultiples2'
import ReservationSeuleSelection from './ReservationSeule3'
import ReservationSeuleSommaire from './ReservationSeule4'
import swal from 'sweetalert';
import moment from 'moment-with-locales-es6';

let loading = false;

class ReservationMultiples extends BoostedComponent {
  constructor(props) {
    super(props)
    this.state = {
      view: 0,
      du: null,
      au: null,
      jourChoisi: null,
      activites: [],
    }
    this.constants = this.props.constants;
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.view !== this.state.view) {

      window.jQuery("html,body").animate({scrollTop: window.jQuery(".reservationMultipleApp").offset().top - 80},300)
      window.location.hash = "multiple"+this.state.view
    }
  }
  componentDidMount() {
    window.addEventListener("hashchange", (e)=> {
      let newView = 0
      if (window.location.hash.substring(1,9) === 'multiple') {
        let number = window.location.hash.substring(9);
        let hashData = number.split("-")

        newView = parseInt(hashData[0]);
        if (window.jQuery(window).width() < 768) {
          if (window.location.hash == "#multiple0") {
            window.jQuery("html,body").animate({scrollTop: window.jQuery(".reservationMultipleApp").offset().top - 80},300)

          }
        }

        if (newView  == 4 && (!this.state.responsable_telephone || !this.state.responsable_nom || !this.state.responsable_courriel || !this.state.activite_nom))  newView = 2
        if (newView  >= 2 && (this.state.problemes || !this.state.aReserver || this.state.aReserver.length == 0)) newView = 2;
        if (newView  >= 1 && !this.state.selected) newView = 0;

      }
      if (this.state.view !== newView) {
        this.setState({
          view: newView
        })
      }

    });
  }
  gotoView = (number) => {
    if  (this.state.view > number) {
      this.setState({
        view: number
      })
    }
  }
  send = () => {
    let thisComponent = this;
    if (!loading) {
      loading = true;
    window.jQuery.ajax({
      dataType: 'json',
      url: this.props.constants.ajaxurl,
      method: 'POST',
      crossDomain: true,
      data: {
        action: 'schedulePublicSaveCommande',
        activite_nom: this.state.activite_nom,
        responsable_courriel: this.state.responsable_courriel,
        responsable_nom: this.state.responsable_nom,
        responsable_telephone: this.state.responsable_telephone,
        activites: this.state.aReserver,
        type: this.props.constants.options.type
      },
      success: (response) => {
        loading = false;

        if (!response.success) {
          if (response.message) {
            let res = document.createElement("div")
            res.innerHTML = response.message;
            swal({
              title: "Erreur",
              content: res,
              icon: "error",
              button: 'Ok'
            })

          }
        } else {
          thisComponent.setState({
            view: 4
          })
        }
      }
    });
  }
  }
  render() {
    return (
      <div>
        {this.state.view <= 3 &&
          <ul className="reservationProgressLine multiple">
            <li className={(this.state.view >= 0 ? 'active' : '')} onClick={this.gotoView.bind(null, 0)}>{this.constants.disponibilite}</li>
            <li className={(this.state.view >= 1 ? 'active' : '')} onClick={this.gotoView.bind(null, 1)}>{this.constants.horaire}</li>
            <li className={(this.state.view >= 2 ? 'active' : '')} onClick={this.gotoView.bind(null, 3)}>{this.constants.sommaire}</li>
            <li className={(this.state.view >= 3 ? 'active' : '')} onClick={this.gotoView.bind(null, 4)}>{this.constants.information}</li>
          </ul>
        }
        <div style={{ display: (this.state.view === 0) ? 'block' : 'none' }}>
          <ReservationMultiplesDispo
            parent={this}
            constants={this.constants}
            />
          {this.state.selected &&
            <div className="buttons">
              <button className="next" onClick={(e)=>{
                  this.setState({
                    view: 1
                  })
                }}>{this.constants.next}</button>
              </div>
            }
          </div>
          <div style={{ display: (this.state.view === 1) ? 'block' : 'none' }}>
            <ReservationMultiplesHoraire
              parent={this}
              selected={this.state.selected}
              constants={this.constants}
              />
            <div className="buttons">
              <button className="prev" onClick={(e)=>{
                  this.setState({
                    view: 0
                  })
                }}>
                {this.constants.prev}
              </button>
              { this.state.aReserver && this.state.aReserver.length>0 &&
                <button className="next" onClick={(e)=>{
                    let conteur = 0;
                    if (this.state.aReserver) {
                      conteur = [0,1,2,3,4,5,6].map(i => {
                        return this.state.aReserver.filter(j => {
                          if (i == moment.utc(j.debut*1000).day()) return true;
                          return false
                        }).length;
                      })
                      conteur = Math.max(...conteur)
                    }


                      this.setState({
                        view: 2
                      })


                  }}>{this.constants.next}
                </button>
              }
            </div>
          </div>
          <div style={{ display: (this.state.view === 2) ? 'block' : 'none' }}>
            <ReservationSeuleSommaire

              parent={this}
              aReserver={this.state.aReserver}
              constants={this.constants}
              />
            <div className="buttons">
              <button className="prev" onClick={(e)=>{
                  this.setState({
                    view: 1
                  })
                }}>
                {this.constants.prev}
              </button>

              <button className="next" onClick={(e)=>{
                  this.setState({
                    view: 3
                  })
                }}>{this.constants.next}
              </button>
            </div>
          </div>
          <div style={{ display: (this.state.view === 3) ? 'block' : 'none' }}>
            <ReservationInformations
              parent={this}
              constants={this.constants}
              />
            <div className="buttons">
              <button className="prev" onClick={(e)=>{
                  this.setState({
                    view: 2
                  })
                }}>
                {this.constants.prev}
              </button>
              { (this.state.responsable_telephone && this.state.responsable_nom && this.state.responsable_courriel && this.state.activite_nom)  &&
                <button className="send" onClick={this.send}>{this.constants.send}</button>
              }
            </div>
          </div>
          <div
            style={{ display: (this.state.view === 4) ? 'block' : 'none' }}
            dangerouslySetInnerHTML={{__html: this.constants.felicitations.replace('%RESPONSABLE%',this.state.responsable_nom)}}
            />
        </div>
      )
    }
  }
  export default ReservationMultiples;



// WEBPACK FOOTER //
// ./src/ReservationMultiples.js